import { SVGProps } from 'react';

export const UploadIcon2 = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    aria-hidden="true"
    width="16pt"
    height="16pt"
    version="1.1"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="m50 79.309c2.5898 0 4.6875-2.1016 4.6875-4.6875v-53.93l21.668 21.672c0.91406 0.91406 2.1172 1.3711 3.3164 1.3711s2.3984-0.45703 3.3164-1.3711c1.832-1.832 1.832-4.7969 0-6.6289l-29.672-29.672c-1.7578-1.7578-4.8711-1.7578-6.6289 0l-29.672 29.672c-1.832 1.832-1.832 4.7969 0 6.6289s4.7969 1.832 6.6289 0l21.668-21.672v53.93c0 2.5898 2.0977 4.6875 4.6875 4.6875z"
        fill="currentcolor"
      />
      <path
        d="m10.52 64.211c-2.5898 0-4.6875 2.1016-4.6875 4.6875v21.727c0 2.5859 2.0977 4.6875 4.6875 4.6875h78.961c2.5898 0 4.6875-2.1016 4.6875-4.6875v-21.727c0-2.5859-2.0977-4.6875-4.6875-4.6875-2.5898 0-4.6875 2.1016-4.6875 4.6875v17.039h-69.586v-17.039c0-2.5898-2.0977-4.6875-4.6875-4.6875z"
        fill="currentcolor"
      />
    </g>
  </svg>
);
